import React, { useState, useRef, useEffect } from "react";
import {
  Paper,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Checkbox,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  InputLabel,
  Autocomplete,
  CircularProgress,
  InputAdornment,
  Radio,
  RadioGroup,
  Backdrop,
  FormHelperText,
} from "@material-ui/core";
import { Delete } from "@mui/icons-material";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  successColor,
  tooltip,
  cardTitle,
  grayColor,
  defaultFont,
  blackColor,
} from "../../../StyledComponents/material-dashboard-pro-react";
import { ArrowBack } from "@mui/icons-material";

import FormControlLabel from "@material-ui/core/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import { useNavigate } from "react-router-dom";
import VenderCode from "../../Invoices/NewInvoice/Dropdowns/VenderCode";
import axios from "axios";
import { formatDateTimeForBackend } from "../../../Functions";
import VendorFinancingTable from "../../VendorFinancing/Tables/VendorFinancing_Table";
import { uploadAdditioalDocumentFile } from "../actions";
import { dashboardStyle } from "../../Invoices/Components/InvoiceDetails/style";
import VFDownload from "../../VendorFinancing/Tables/VFDownload";
import PaymentInv_Table from "./PaymentInv_Table";
import CustomSnackbar from "../../../CustomSnackbar";
import { getInvoiceType,getSignatories } from "../AdminSetting/adminaction";
import { getUsersByRole } from "../actions";
import AlertDialog from "../../Home/alert";
import * as XLSX from "xlsx";
import { batchExcelUploadFile } from "./batchExcelUpload";
import getParameterByName from "../../../Functions/functions";

const useStyles = makeStyles(dashboardStyle);
const commentBox = {
  fontFamily: "DM Sans,sans-serif",
  fontWeight: "400",
  fontSize: "0.875rem",
  width: "100%",

  resize: "none",
  overflow: "hidden",
  outline: "none",
  height: "40px",
  marginTop: "16px",
  color: "#888888",
};
const PaymentReport = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const Date = getParameterByName("Date");
  const cancelfileUpload = useRef(null);
  const [sentToTreasury, setsentToTreasury] = useState(
    "yet to be sent to Treasury"
  );
  // const [attachmentLoader, setAttchmentLoader] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [emailloader, setEmailLoader] = useState(false);
  const [count, setCount] = useState(0);
  const [signatory, setSignatory] = useState([]);
  const [archieve, setIsArchieve] = useState("false");
  const [batchNo, setBatchNo] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [validation, setValidation] = useState("");
  const [validationforSignatories, setValidationforSignatories] =
    useState(false);
  const [stopUpload, setStopUload] = useState(false);
  const [ExcelFile, setExcelFile] = useState("");
  const [signatorylist, setSignatoryList] = useState([]);
  const [signatories, setSignatories] = useState([]);
  const [filterSignatories,setFilterSignatories]= useState([]);
  const [chequeNo, setChequeNo] = useState([]);

  const [Batch, setBatch] = useState({
    invoice: "",
    comment: "",
  });

  const [treasuryState, setTreasuryState] = useState({
    invoices: "",
    treasury: "",
    remarks: "",
  });
  const [formState, setFormState] = useState({
    clearingDateFrom: Date? Date : moment().subtract(3, "d").format("YYYY-MM-DD"),
    clearingDateTo: Date? Date : moment().format("YYYY-MM-DD"),
    batchFromDate: Date? Date : moment().subtract(3, "d").format("YYYY-MM-DD"),
    batchToDate: Date? Date : moment().format("YYYY-MM-DD"),
    vendor_Code: "",
    signatory: [],
    RowsOfPage: 10,
    PageNo: 1,
  });
  const ITEM_HEIGHT = 40;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        zIndex: 999,
      },
    },
  };


  const getBtachesData = async () => {
    setInvoiceLoading(true);
    const axios = require("axios");
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/api/Signatory/GetBatch?isArchive=${archieve == "true" ? true : false
        }&fromDate=${formState?.clearingDateFrom}&toDate=${formState?.clearingDateTo
        }`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    };
    axios
      .request(config)
      .then((response) => {
        setCount(response.data.length);
        setInvoices(response.data);
        setInvoiceLoading(false);
      })
      .catch((error) => {

      });
  };
  const getBatchRef = async () => {
    const axios = require("axios");

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/api/VFPayments/GetBatch`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    };
    axios
      .request(config)
      .then((response) => {

        setSignatory(response.data);
      })
      .catch((error) => {

      });
  };
 
  useEffect(() => {
    getBatchRef();
    // getUsersByRole("Signatory", setSignatoryList,()=>{});
    getSignatories("Signatory", setSignatoryList,)
  }, []);

  // useEffect(() => {
  //   
  // }, [formState]);
  useEffect(() => {
    getBtachesData();
  }, [archieve]);
  const getbatches = async () => {
    getBtachesData();
  };
  const voidCheques = async () => {

    const axios = require("axios");

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/api/Signatory/VoidCheques?chequeNos=${chequeNo}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
    };

    axios
      .request(config)
      .then((response) => {

        setSuccessMessage("Your cheque is Successfully voided");
      })
      .catch((error) => {

        setErrorMessage(error.response.data);
      });
  };
  const sendEmail = async () => {

    const axios = require("axios");

    if (formState?.signatory?.length === 0) {
      setValidationforSignatories(true);
      return; // Exit the function early if validation fails
    } else {
      setValidationforSignatories(false);
    }

    if (batchNo.length === 0) {
      setValidation("Please Select Batches");
      setEmailLoader(false);
      return; // Exit the function early if validation fails
    } else {
      setValidation("");
    }

    setEmailLoader(true);
    let config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL
        }/api/Signatory/SendSignatoryEmail?batchText=${batchNo.toString()}&signatoryEmails=${formState.signatory
        }`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
    };

    try {
      const response = await axios.request(config);

      setEmailLoader(false);
      setBatchNo([]);

      setValidation("");
      setValidationforSignatories("");
      setSuccessMessage("Email has been sent to signatories successfully");
    } catch (error) {

      setEmailLoader(false);
      setValidation("");
      setValidationforSignatories(false);
    }
  };

  // const sendEmail = async () => {
  //   
  //   const axios = require("axios");
  //    if (formState?.signatory === ""){
  //     setValidationforSignatories(true);
  //   } else if (formState?.signatory){
  //     setValidationforSignatories(false);
  //   }
  //   else if (batchNo?.length === 0 ) {
  //     setValidation("Please Select Batches");
  //     setEmailLoader(false);
  //   }else if (batchNo?.length > 0){
  //     setValidation("");
  //   }else {
  //     setEmailLoader(true);
  //     let config = {
  //       method: "post",
  //       url: `${
  //         process.env.REACT_APP_API_URL
  //       }/api/Signatory/SendSignatoryEmail?batchText=${batchNo.toString()}&signatoryEmails=${
  //         formState.signatory
  //       }`,
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("user_token")}`,
  //       },
  //     };

  //     axios
  //       .request(config)
  //       .then((response) => {
  //         
  //         setEmailLoader(false);
  //         setValidation("")
  //         setValidationforSignatories("")
  //         setSuccessMessage("Email has been send to signatories successfully");
  //       })
  //       .catch((error) => {
  //         
  //         setEmailLoader(false);
  //         setValidation("")
  //         setValidationforSignatories()("")
  //       });
  //   }
  // };
  const additionalAttachmentRef = useRef(null);
  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };
  const archieveInvoices = async () => {
    setInvoiceLoading(true);
    if (batchNo.length === 0) {
      setValidation("Please Select Batches");
      setInvoiceLoading(false);
    } else {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/api/Signatory/${archieve == "false" ? "ArchiveBatches" : "UnArchiveBatches"
          }?batchNos=${batchNo.toString()}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        },
      };

      axios
        .request(config)
        .then((response) => {
          // setInvoices([])
          getBtachesData();
          setBatchNo([]);
          setSuccessMessage(
            archieve == "false"
              ? "Invoices Archieve Successfully "
              : "Invoices UnArchieve Successfully"
          );
          setValidation("");
          setValidationforSignatories();
          setInvoiceLoading(false);
        })
        .catch((error) => {

        });
    }
  };
  const deleteBatch = async () => {
    setInvoiceLoading(true);
    if (batchNo.length === 0) {
      setValidation("Please Select Batches");
      setInvoiceLoading(false);
    } else {
      setInvoiceLoading(true);

      let config = {
        method: "Delete",
        url: `${process.env.REACT_APP_API_URL
          }/api/Signatory/DeleteBatches?batchNos=${batchNo.toString()}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        },
      };

      axios
        .request(config)
        .then((response) => {
          // setInvoices([])
          getBtachesData();
          setBatchNo([]);
          setSuccessMessage(" Batch Delete Successfully");
          setValidation("");
          setValidationforSignatories("");
          setInvoiceLoading(false);
        })
        .catch((error) => {

          setInvoiceLoading(false);
        });
    }
  };
  const [attchmentLoader, setAttchmentLoader] = useState(false);
  const [csvFile, setCSVFile] = useState("");


  const [alertMessage, setAlertMessage] = useState(false);
  const [alertList, setAlertList] = useState([]);

  const readUploadFile = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[sheetName];

        const stringified = JSON.stringify(worksheet);

        const noOfLoops = XLSX.utils.sheet_to_json(worksheet);


        let parse = JSON.parse(stringified);

        batchExcelUploadFile(
          file,
          parse,
          additionalAttachmentRef,
          noOfLoops,
          setErrorMessage,
          setSuccessMessage,
          setAttchmentLoader,
          setAlertList,
          setAlertMessage,
          getBtachesData,
          cancelfileUpload,
          setExcelFile
        );
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const stopUploadFile = () => {

    if (cancelfileUpload.current) {
      cancelfileUpload.current("cancel upload");
    }
    setStopUload(true);
  };
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };
  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage,
    }));
  };
  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));

    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
    // setPage(0);
  };
  return (
    <Card style={{ marginLeft: "20px" }}>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={emailloader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "1px 20px",
            backgroundColor: "#031C30",
            color: "white",
            height: "62px",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <h4>Payment Report Interface</h4>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <form>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={12} md={4} lg={3}>
              <FormControl component="fieldset">
                {/* <FormLabel
                  required
                  // classes={{ asterisk: classes.asterisk }}
                  id="demo-row-radio-buttons-group-label"
                >
                  <b>Treasury</b>
                </FormLabel> */}
                <Typography>
                  <span className={classes.asterisk}>*</span>
                  Batch:
                </Typography>
                <RadioGroup
                  row
                  aria-label="gender"
                  name="gender1"
                  value={archieve}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  onChange={(e) => {

                    setIsArchieve(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value={"false"}
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#C5C7CD",
                          "&.Mui-checked": {
                            color: "#0095DA",
                          },
                        }}
                      />
                    }
                    label="Active Batched"
                  />
                  <br />
                  <FormControlLabel
                    value={"true"}
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#C5C7CD",
                          "&.Mui-checked": {
                            color: "#0095DA",
                          },
                        }}
                      />
                    }
                    label="Archived Batched"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={6}
              sm={6}
              md={4}
              lg={3}
              style={{ paddingRight: "18px" }}
            >
              <Typography>Date From:</Typography>
              <input
                className={classes.inputField}
                type="date"
                max="9999-12-31"
                value={formState.clearingDateFrom}
                onChange={(newValue) => {
                  autocompleteChangeHandler(
                    "clearingDateFrom",
                    newValue.target.value,
                    formatDateTimeForBackend(newValue)
                  );
                }}
                style={{ height: 13 }}
              />
              {/*<LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={formState.clearingStartDate}
              onChange={(newValue) => {
                autocompleteChangeHandler(
                  "clearingStartDate",
                  formatDateTimeForBackend(newValue)
                );
              }}
              error={false}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  size="small"
                  id="outlined-basic"
                  label="Outlined"
                  variant="outlined"
                  {...params}
                  error={false}
                />
              )}
            />
              </LocalizationProvider>*/}
            </Grid>

            <Grid
              item
              xs={6}
              sm={6}
              md={4}
              lg={3}
              style={{ paddingRight: "18px" }}
            >
              <Typography>Date To:</Typography>
              <input
                className={classes.inputField}
                type="date"
                max="9999-12-31"
                value={formState.clearingDateTo}
                onChange={(newValue) => {
                  autocompleteChangeHandler(
                    "clearingDateTo",
                    newValue.target.value,
                    formatDateTimeForBackend(newValue)
                  );
                }}
                style={{ height: 13 }}
              />
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={formState.ClearingEndDate}
                onChange={(newValue) => {
                  autocompleteChangeHandler(
                    "ClearingEndDate",
                    formatDateTimeForBackend(newValue)
                  );
                }}
                error={false}
                renderInput={(params) => (
                  <TextField
                    fullWidth
                    size="small"
                    id="outlined-basic"
                    label="Outlined"
                    variant="outlined"
                    {...params}
                    error={false}
                  />
                )}
              />
                </LocalizationProvider>*/}
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={3}>
              <Typography>
                <span className={classes.asterisk}>*</span>Sent To:
              </Typography>
              <Select
                name="signatory"
                displayEmpty
                labelId="demo-simple-select-label"
                multiple
                // required
                label="Select Signatories"
                value={filterSignatories}
                variant="outlined"
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return "Select Signatories";
                  }
                  return selected.join(", ");
                }}
                onChange={(event) => {
                  const {
                    target: { value },
                  } = event;

                  setFilterSignatories(
                    typeof value === "string" ? value.split(",") : value
                  );
              
                }}
                style={{ height: 30 }}
                InputLabelProps={{
                  shrink: false,
                  required: false,
                  className: classes.hs_form_required,
                }}
                MenuProps={MenuProps}
                fullWidth
                size="small"
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                error={validationforSignatories ? true : false}
              >
                {signatorylist?.length > 0 ? (
                  signatorylist.map((item) => (
                    <MenuItem
                      key={item.ReferenceProp1}
                      value={item.ReferenceProp1}
                    >
                      {item.ReferenceProp1}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">No option</MenuItem>
                )}
              </Select>
            


              <FormHelperText style={{ color: "red" }}>
                {validationforSignatories && "Please Select Signatories"}
              </FormHelperText>

            </Grid>
          </Grid>
          <Grid container mt={1}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ display: "flex" }}
            >
              <Button
                variant="contained"
                size="small"
                color="secondary"
                style={{
                  marginLeft: "6px",
                  padding: "9px",
                  marginTop: "20px",
                  height: 32
                }}
                p={4}
                onClick={archieveInvoices}
              >
                {archieve == "false" ? "Archive " : "UnArchive"}
              </Button>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                style={{
                  marginLeft: "6px",
                  padding: "9px",
                  marginTop: "20px",
                  height: 32

                }}
                p={4}
                onClick={deleteBatch}
              >
                Delete
              </Button>

              <Button
                variant="contained"
                size="small"
                color="secondary"
                style={{
                  marginLeft: "6px",
                  padding: "9px",
                  marginTop: "20px",
                  height: 32

                }}
                p={4}
                disabled={attchmentLoader}
              // onClick={PostTreasury}
              >
                <input
                  id="raised-button-file"
                  type="file"
                  name="upload"
                  accept=".xlsx,.csv"
                  style={{
                    display: "none", height: 32
                  }}
                  ref={additionalAttachmentRef}
                  onChange={(e) => readUploadFile(e)}
                />
                <label htmlFor="raised-button-file" style={{ color: "white" }}>
                  Upload CSV
                </label>
              </Button>
              <span>
                {attchmentLoader ? (
                  <Box mt={3} style={{ padding: "10px" , marginBottom: "6px" }}>
                    <CircularProgress color="info" size={20} />
                  </Box>
                ) : (
                  ExcelFile && (
                    <>
                      <Box mt={3}>
                        <IconButton
                          size="small"
                          onClick={() => {
                            setExcelFile("");
                          }}
                        >
                          <Delete
                            titleAccess="Delete"
                            color="danger"
                            fontSize="small"
                          />
                        </IconButton>
                        {ExcelFile}
                      </Box>
                    </>
                  )
                )}
              </span>

              <Button
                variant="contained"
                size="small"
                color="secondary"
                style={{
                  marginLeft: "6px",
                  padding: "0px 6px",
                  marginTop: "20px",
                  height: 32

                }}
                p={4}
                onClick={stopUploadFile}
              >
                Stop Upload
              </Button>
                <Button
                variant="contained"
                size="small"
                color="secondary"
                style={{
                  marginLeft: "6px",
                  padding: "0px 6px",
                  marginTop: "20px",
                  height: 32

                }}
                p={4}
                onClick={getbatches}
              >
                Search
              </Button>
            </Grid>
          </Grid>
          <Grid container mt={1} spacing={2}>
            <Grid item xs={6} sm={6} md={4} lg={3}>
              <Typography>
                <span className={classes.asterisk}>*</span>Select Signatories:
              </Typography>
              {/* <Select
                name="signatory"
                displayEmpty
                labelId="demo-simple-select-label"
                multiple
                required
                label="select signatories "
                value={signatories}
                variant="outlined"
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return "Select Signatories ";
                  }

                  return selected.join(", ");
                }}
                onChange={(event) => {
                  
                  const {
                    target: { value },
                  } = event;

                  
                  setSignatories(
                    // On autofill we get a stringified value.
                    typeof value === "string" ? value.split(",") : value
                  );
                  setFormState((formState) => ({
                    ...formState,
                    signatory: value.toString(),
                  }));
                  // changeHandler(referenceTextlist)
                }}
                // label={formState.signatory === "" ? "Select a Value" : ""}
                InputLabelProps={{
                  shrink: false,
                  required: false,
                  className: classes.hs_form_required,
                }}
                MenuProps={MenuProps}
                // SelectProps={{ multiple: true }}
                fullWidth
                size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 }
                }}
                error={validationforSignatories ? true : false}
              
              >
                {signatorylist?.length > 0 ? (
                  signatorylist.map((item) => (
                    <MenuItem value={item.ReferenceProp1
                    }>
                      {item.ReferenceText}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">No option</MenuItem>
                )}
              </Select> */}
              <Select
                name="signatory"
                displayEmpty
                labelId="demo-simple-select-label"
                multiple
                required
                label="Select Signatories"
                value={signatories}
                variant="outlined"
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return "Select Signatories";
                  }
                  return selected.join(", ");
                }}
                onChange={(event) => {
                  const {
                    target: { value },
                  } = event;

                  setSignatories(
                    // On autofill we get a stringified value.
                    typeof value === "string" ? value.split(",") : value
                  );

                  // If you want to save the selected item.ReferenceProp1 value in formState.signatory,
                  // you can do this:
                  const selectedItems = signatorylist.filter((item) =>
                    value.includes(item.ReferenceText)
                    // value.includes(item.userName)

                  );
                  const selectedProp1Values = selectedItems.map(
                    (item) => item.ReferenceProp1
                    // (item) => item.userId

                  );

                  setFormState((formState) => ({
                    ...formState,
                    signatory: selectedProp1Values.join(","), // Save ReferenceProp1 values as a comma-separated string
                  }));
                }}
                style={{ height: 30 }}
                InputLabelProps={{
                  shrink: false,
                  required: false,
                  className: classes.hs_form_required,
                }}
                MenuProps={MenuProps}
                fullWidth
                size="small"
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                error={validationforSignatories ? true : false}
              >
                {signatorylist?.length > 0 ? (
                  signatorylist.map((item) => (
                    <MenuItem
                      key={item.ReferenceProp1}
                      value={item.ReferenceText}
                      // key={item.userId}
                      // value={item.userName}
                    >
                      {item.ReferenceText} - {item.ReferenceProp2 === "true" ? "Category A" : "Category B"}
                      {/* {item.userName} */}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">No option</MenuItem>
                )}
              </Select>

              <FormHelperText style={{ color: "red" }}>
                {validationforSignatories && "Please Select Signatories"}
              </FormHelperText>

              {/* <Autocomplete
                id="selectStatus"
                options={signatory}
                size="small"
                name="signatory"
                required
                value={formState.signatory}
                getOptionLabel={(option) =>
                  (option !== "" && `${option?.BatchRef || ""}`) || ""
                }
                onChange={(e, newValue) => {
                  
                  let objVendor = {
                    target: {
                      name: "signatory",
                      value: newValue,
                    },
                  };
                  changeHandler(objVendor);
                  
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name=""
                    required
                    label={formState.signatory === "" ? "Select a Value" : ""}
                    value={""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
                  />*/}
            </Grid>
            <Grid item xs={6} sm={6} md={2} lg={3}>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                style={{
                  padding: "9px", marginTop: "20px",
                  height: 32
                }}
                p={4}
                onClick={sendEmail}
              >
                Send Email
              </Button>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={3}>
              <Typography>Cheque No</Typography>
              <TextField
                fullWidth={true}
                id="outlined-basic"
                variant="outlined"
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 30,
                  }
                }}
                type="text"
                name="chequeNo"
                value={chequeNo}
                required
                onChange={(e) => setChequeNo(e.target.value)}
                placeholder={"add cheque no."}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={3}>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                style={{
                  marginLeft: "6px",
                  padding: "9px",
                  marginTop: "20px",
                  height: 32

                }}
                p={4}
                onClick={() => voidCheques()} // Call the function
              >
                Void Cheque(s)
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <PaymentInv_Table
              vendorList={invoices}
              loading={invoiceLoading}
              page={formState.PageNo}
              RowsPerPage={formState.RowsOfPage}
              batchNo={batchNo}
              setBatchNo={setBatchNo}
              errorMessage={validation}
              signatory={filterSignatories}
            />

            {/*  <VFDownload
             vendorList={invoices}
             getInvoices={getInvoices}
             loading={invoiceLoading}
             Batch={Batch}
             setBatch={setBatch}
            setSuccessMessage={setSuccessMessage}
            page={formState.PageNo}
            RowsPerPage={formState.RowsOfPage}
            batchNo={batchNo}
            setBatchNo={setBatchNo}
            errorMessage={errorMessage}
            
          />
          */}
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={count}
              rowsPerPage={formState.RowsOfPage}
              page={parseInt(formState.PageNo) - 1}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            {successMessage && (
              <CustomSnackbar
                open={successMessage !== ""}
                message={successMessage}
                handleClose={() => setSuccessMessage("")}
                variant="success"
              />
            )}
            {errorMessage && (
              <CustomSnackbar
                open={errorMessage !== ""}
                message={errorMessage}
                handleClose={() => setErrorMessage("")}
                variant="error"
              />
            )}
          </Grid>
          {alertMessage && (
            <AlertDialog Alert={alertList} setAlertMessage={setAlertMessage} />
          )}
        </form>
      </CardBody>
    </Card>
  );
};

export default PaymentReport;
